import CheckoutPrivacyFlags from '@components/checkout/CheckoutPrivacyFlags';
import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExpressPaymentsButtonAmazonpay from './ExpressPaymentsButtonAmazonpay';
import ExpressPaymentsButtonApplepay from './ExpressPaymentsButtonApplepay';
import ExpressPaymentsButtonGooglepay from './ExpressPaymentsButtonGooglepay';
import ExpressPaymentsButtonPaypal from './ExpressPaymentsButtonPaypal';
import ExpressTaxInfoForm from './ExpressTaxInfoForm';
import { autoChooseClassnames, autoChooseComponent, getId } from '@common/utils/brandDiffsUtils';
const ExpressPaymentsButtons = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const [enablePlaceorder, setEnablePlaceorder] = useState();
    const [showFlags, setShowFlags] = useState();
    const [confirmed, setConfirmed] = useState();
    const [selectedMethod, setSelectedMethod] = useState();
    const { reloadtimestamp } = props;
    const [taxCodeHK, setTaxCodeHK] = useState(window.country == 'HK' ? false : true); // mandatory for delivery on HK
    const [hasErrors, setHasErrors] = useState(false);
    const flagsWrapper = useRef();
    const paymentName = useMemo(() => {
        let paymentId = selectedMethod === 'googlepay' ? 'paywithgoogle' : selectedMethod;
        return (paymentId && t(`paymentmethod.${paymentId}`)) || '';
    }, [selectedMethod]);
    const googlePaymentRef = useRef(null);
    useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.onUpdate) {
            console.info('update altezza express payment buttons');
            props.onUpdate();
        }
        if (!showFlags) {
            setConfirmed(false);
        }
        else {
            setTimeout(() => {
                var _a;
                (_a = flagsWrapper.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 200);
        }
    }, [showFlags]);
    useEffect(() => {
        setSelectedMethod(null);
        setShowFlags(false);
    }, [reloadtimestamp]); // force reload
    // OE-24851 workaround to use both arrow with different behaviors
    const addArrowAfterClick = () => {
        const paymentDiv = document.querySelector('.minibag__expresspayment__intro');
        if (paymentDiv) {
            paymentDiv.classList.add('button--arrow-left');
        }
    };
    const clickPlaceOrder = (event) => {
        var _a;
        if (!enablePlaceorder || !taxCodeHK) {
            event.preventDefault();
            setHasErrors(true);
            setTimeout(() => {
                var _a, _b;
                (_b = (_a = flagsWrapper.current) === null || _a === void 0 ? void 0 : _a.querySelector('.is-invalid')) === null || _b === void 0 ? void 0 : _b.focus();
            }, 200);
            return false;
        }
        setHasErrors(false);
        setConfirmed(true);
        if (selectedMethod == 'googlepay') {
            setSelectedMethod(undefined);
            setShowFlags(false);
            (_a = googlePaymentRef === null || googlePaymentRef === void 0 ? void 0 : googlePaymentRef.current) === null || _a === void 0 ? void 0 : _a.placeOrderWithGoogle();
        }
        // needed for "Must create a new ApplePaySession from a user gesture handler"
        if (selectedMethod == 'applepay') {
            console.log('applepaybutton click');
            document.getElementById('applepaybutton').click();
        }
        event.preventDefault();
    };
    const arraySort = () => window.activedPaymentMethodCheckoutExpress.split(',').map((e) => {
        return !selectedMethod && e == 'paypal' ? (React.createElement(ExpressPaymentsButtonPaypal, Object.assign({ key: e, onPaymentSelected: () => {
                if (getId() == 'ST') {
                    props === null || props === void 0 ? void 0 : props.analyticsStone('paypal');
                }
                else {
                    analytics.expressCheckoutPaymentSelected('paypal');
                }
            } }, props))) : (!selectedMethod || selectedMethod == 'applepay') && e == 'applepay' ? (React.createElement(ExpressPaymentsButtonApplepay, Object.assign({ key: e, onPaymentSelected: () => {
                if (getId() == 'ST') {
                    props === null || props === void 0 ? void 0 : props.analyticsStone('apple');
                }
                else {
                    analytics.expressCheckoutPaymentSelected('apple');
                }
            } }, props, { confirmed: confirmed, isSelected: selectedMethod == 'applepay', ariaControls: "express-modal-fieldset", showFlagsCallback: () => {
                setSelectedMethod('applepay');
                setShowFlags(true);
            } }))) : !selectedMethod && e == 'amazonpay' ? (React.createElement(ExpressPaymentsButtonAmazonpay, Object.assign({ key: e, onPaymentSelected: () => {
                if (getId() == 'ST') {
                    props === null || props === void 0 ? void 0 : props.analyticsStone('amazon');
                }
                else {
                    analytics.expressCheckoutPaymentSelected('amazon');
                }
            } }, props))) : ((!selectedMethod || selectedMethod == 'googlepay') &&
            e == 'googlepay' && (React.createElement(ExpressPaymentsButtonGooglepay, Object.assign({ key: e, onPaymentSelected: () => {
                if (getId() == 'ST') {
                    props === null || props === void 0 ? void 0 : props.analyticsStone('google');
                }
                else {
                    analytics.expressCheckoutPaymentSelected('google');
                }
            } }, props, { isSelected: selectedMethod == 'googlepay', confirmed: confirmed, ariaControls: "express-modal-fieldset", showFlagsCallback: () => {
                setSelectedMethod('googlepay');
                setShowFlags(true);
            }, ref: googlePaymentRef }))));
    });
    return (React.createElement(React.Fragment, null,
        arraySort(),
        React.createElement("fieldset", { "aria-labelledby": "express-modal-legend", id: "express-modal-fieldset", ref: flagsWrapper, tabIndex: -1 }, showFlags && (React.createElement(React.Fragment, null,
            React.createElement("legend", { id: "express-modal-legend", className: "d-none" },
                t('checkout.expresscheckout'),
                ": ",
                paymentName),
            selectedMethod && (React.createElement("button", { className: autoChooseClassnames({ ST: 'button--secondary' }, 'button button--arrow-back'), onClick: () => {
                    addArrowAfterClick();
                    setSelectedMethod(undefined);
                    setShowFlags(false);
                    props.onUpdate && props.onUpdate();
                    props.onBackPress && props.onBackPress();
                }, "aria-label": t('button.back') }, !window.appmode &&
                autoChooseComponent({
                    MO: (React.createElement("span", null,
                        React.createElement("i", { className: "icon--chevron-left", "aria-hidden": true }))),
                    ST: (React.createElement(React.Fragment, null,
                        React.createElement("i", { className: "icon--chevron-left", "aria-hidden": true }),
                        React.createElement("span", null, t('button.back')))),
                }))),
            window.country == 'HK' && React.createElement(ExpressTaxInfoForm, { setIsValidTaxForm: setTaxCodeHK }),
            React.createElement(CheckoutPrivacyFlags, Object.assign({}, props, { guest: (_a = props === null || props === void 0 ? void 0 : props.bag) === null || _a === void 0 ? void 0 : _a.guest, onSelect: setEnablePlaceorder, hidedataprocessing: true, containsMbm: !!((_b = props === null || props === void 0 ? void 0 : props.bag) === null || _b === void 0 ? void 0 : _b.items.find((el) => el.isMbm)), mbmurllegalareareturn: (props === null || props === void 0 ? void 0 : props.mbmurllegalareareturn) || (props === null || props === void 0 ? void 0 : props.returnpolicy), forceValidation: true, showValidationErrors: hasErrors })),
            React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: clickPlaceOrder, ariaDescribedby: "expresscheckout-guestdesc" }, t('checkout.placeorder')),
            ((_c = props === null || props === void 0 ? void 0 : props.bag) === null || _c === void 0 ? void 0 : _c.guest) && (React.createElement("p", { id: "expresscheckout-guestdesc", "aria-hidden": true, className: "data-processing", dangerouslySetInnerHTML: { __html: t('checkout.review.dataprocessing') } })))))));
};
export default ExpressPaymentsButtons;
